import { type ReferentPriceType } from '@strata/constants';
import { DateFormats, formatDate } from '@strata/helper-functions';
import { CurrentBid } from '@strata/react-current-bid';
import { FormSectionWithRows } from '@strata/react-form-section';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';

import { type ReferralDetails } from 'store/api/treatmentApi';

interface ServicingDetailsProps {
    selectedReferral?: { offerRate?: string; referentPriceType?: ReferentPriceType };
    referralDetails?: ReferralDetails;
}

export const ServicingDetails = ({
    selectedReferral = undefined,
    referralDetails = undefined,
}: ServicingDetailsProps) => (
    <FormSectionWithRows
        sectionTitle="Servicing Details"
        width="50%"
        isLoading={!referralDetails}
        rowOneContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Servicing Rate"
                    value={
                        <CurrentBid
                            bidAmount={
                                // null is a valid value for winningBid, so this rule needs to be ignored
                                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                                referralDetails?.winningBid !== undefined
                                    ? referralDetails.winningBid
                                    : selectedReferral?.offerRate
                            }
                            referentPriceType={
                                referralDetails?.referentPriceType ??
                                selectedReferral?.referentPriceType
                            }
                            bidState={CurrentBid.states.WON}
                        />
                    }
                />
                <DetailLabelValuePair
                    label="Servicing Start Date"
                    value={formatDate(referralDetails?.referralStart, DateFormats.DATE)}
                />
            </>
        }
    />
);
